"use client";
import { useSearchParams } from "next/navigation";

// useSearchParams() para las paginas que se cachean (force-static): en el server
// devuelve una query VACIA; en el navegador, la del visitante, igual que siempre.
//
// Por que: esas paginas se renderizan una vez y el HTML se le sirve a todos (Next una
// hora, CloudFront hasta un dia). Pero el render lo dispara el pedido de UN visitante
// y Next lo hace con la URL de ese pedido, query incluida, aunque la pagina sea
// force-static. Todo lo que un componente dibuje a partir de la query queda pegado en
// el HTML de los demas. Medido en prod el 10-oct-2026: 51 de 200 paginas publicas
// tenian parametros de otro visitante (fbclid, utm, products) y 5 el MAIL de un
// cliente; en /es/libro/mic estaba cargado en el campo de mail, a la vista.
//
// En el navegador no cambia nada: el primer render ya lee la URL real (precio por
// ?cc=, carrito por ?products=, mail por ?email=). Lo unico distinto es el HTML que
// manda el server, que ahora es siempre el de la pagina sin parametros.
//
// Regla: un componente que se dibuja en una pagina force-static usa este hook y NO
// el de next/navigation. Las paginas dinamicas (compra, portal, login, apps) se
// renderizan por visitante y siguen con el de Next.
//
// No se pudo cortar en proxy.js: un rewrite sin query le saca los parametros a la
// pagina, pero Next arma la URL que ve useSearchParams() con el pedido original.
const SIN_PARAMETROS = new URLSearchParams();

export function useSearchParamsDelVisitante() {
  const delPedido = useSearchParams();
  return typeof window === "undefined" ? SIN_PARAMETROS : delPedido;
}
